import { Box, Dialog, DialogContent, DialogTitle, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navigation from '../common/Navigation';
import TopHeader from '../common/TopHeader';
import { Breadcrumbs } from '../../contexts/Breadcrumbs';
import { usePrerequisites } from '../../contexts/Prerequisites';
import { useSetState } from '../../hooks';
import ChangeExpiredPasswordForm from '../../views/forms/ChangeExpiredPasswordForm';

const InternalLayout = ({ children }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const theme = useTheme();
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
	const [state, setState] = useSetState({
		drawerOpen: isLgUp
	});
	const { tags } = useSelector(dataStoreState => dataStoreState.auth)
	const [{ strings, passwordExpiredDialogOpen }, { logoutUser, onChangePasswordSubmit }] = usePrerequisites();
	const handleOnToggleDrawer = useCallback(() => setState((prevState) => ({ drawerOpen: !prevState.drawerOpen })), [])
	const wrapperClass = useMemo(() => `${location.pathname} main-wrapper ${state.drawerOpen ? 'drawer-open' : ''}`, [location.pathname, state.drawerOpen]);


	return (
		<Box>
			<TopHeader />
			<Navigation drawerOpen={state.drawerOpen} onToggleDrawer={handleOnToggleDrawer} />
			<Box
				className={wrapperClass}
				sx={{
					padding: 1,
					paddingTop: 5
				}}
				id="main-page-wrapper"
			>
				<Breadcrumbs />
				{children}
				<Dialog sx={{ zIndex: theme.zIndex.tooltip }} open={passwordExpiredDialogOpen && tags?.RoleName !== "SuperAdmin"}>
					<DialogTitle>{strings.ChangePassword || 'Change Password'}</DialogTitle>
					<DialogContent sx={{ padding: theme.spacing(2, 1, 2) }}>
						<ChangeExpiredPasswordForm
							containerProps={{ elevation: 0, sx: { '& .MuiCardActions-root': { padding: theme.spacing(2, 1) } } }}
							cancelBtnProps={{
								color: 'error',
								onClick: () => {
									logoutUser((path) => {
										setState({ passwordExpiredDialogOpen: false });
									});
								}
							}}
							activeRecord={{}}
							onSubmit={onChangePasswordSubmit}
						/>
					</DialogContent>
				</Dialog>
			</Box>
		</Box>
	);
};


export default InternalLayout;